const githubCheatsheet = {
  title: "GitHub",
  level: "All Levels",
  description: "GitHub workflows, actions, and collaboration features",
  language: "yaml",
  sections: [
    {
      title: "Getting Started",
      icon: "🐙",
      content: [
        {
          title: "Basic Workflow",
          code: `# GitHub Actions Example
name: CI/CD Pipeline

on:
  push:
    branches: [ main ]
  pull_request:
    branches: [ main ]

jobs:
  build:
    runs-on: ubuntu-latest
    steps:
    - uses: actions/checkout@v2
    
    - name: Set up Node.js
      uses: actions/setup-node@v2
      with:
        node-version: '14'
    
    - name: Install dependencies
      run: npm install
    
    - name: Run tests
      run: npm test
    
    - name: Build
      run: npm run build

# Pull Request Template
## Description
<!-- Describe your changes -->

## Related Issues
<!-- Link to related issues -->

## Checklist
- [ ] Tests added
- [ ] Documentation updated
- [ ] Code follows style guidelines`,
          explanation: "Basic GitHub workflows and templates.",
        },
      ],
    },
  ],
};

export default githubCheatsheet;
